import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e432cfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-center" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-600 py-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "select" }, "Selecione um arquivo"),
  /*#__PURE__*/_createTextVNode(" ou arraste e solte")
], -1))

import { /* defineProps, withDefaults, */ ref, watch } from 'vue';
import { PaperPlusIcon, AtomSubTitle } from '@/components/atoms';

// interface IProps {}

// const props = withDefaults(defineProps<IProps>(), {});


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomUpload',
  emits: ['changeFile'],
  setup(__props, { emit }) {


const files = ref<File>();

function changeInput(evt) {
  files.value = evt.target.files;
}

function dragover(event) {
  event.preventDefault();

  event.currentTarget.classList.add('bg-gray-03');
}
function dragleave(event) {
  event.currentTarget.classList.remove('bg-gray-03');
}
function drop(event) {
  event.preventDefault();
  files.value = event.dataTransfer.files;
  event.currentTarget.classList.remove('bg-gray-03');
}

watch(
  () => files.value,
  () => {
    emit('changeFile', files.value);
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: "drop-area d-flex flex-column justify-center",
    onDragover: dragover,
    onDragleave: dragleave,
    onDrop: drop
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(PaperPlusIcon))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(AtomSubTitle), {
        "no-margin": "",
        text: "PDF ou TXT"
      })
    ]),
    _createElementVNode("input", {
      onChange: changeInput,
      id: "upload",
      type: "file",
      class: "d-sr-only",
      accept: ".pdf,.txt"
    }, null, 32)
  ], 32))
}
}

})